import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-port-icon',
  templateUrl: './port-icon.component.html',
  styleUrls: ['./port-icon.component.css']
})
export class PortIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
